import { useIntl } from 'react-intl';

import { IconHomeFilled } from '@xing-com/icons';

import { getCrumbs } from '../../routes/getCrumbs';
import type { Crumb } from '../../routes/getCrumbs';
import type { BreadcrumbsType } from '../../routes/router';
import * as Styled from './breadcrumbs.styles';

const isLastCrumb = ({ crumbs, key }: { crumbs: Crumb[]; key: number }) =>
  key + 1 === crumbs.length;

const Breadcrumbs = ({
  routes,
  match,
}: {
  routes: BreadcrumbsType[];
  match: any;
}) => {
  const intl = useIntl();

  const crumbs: Crumb[] = getCrumbs({ routes, match, intl });

  return (
    <Styled.Container>
      <Styled.HomeButton href={'/'}>
        <IconHomeFilled width={16} height={16} />
      </Styled.HomeButton>
      {crumbs.map(({ name, path }, key) => (
        <Styled.Breadcrumb key={path}>
          <Styled.ArrowIcon direction={'right'} />
          {isLastCrumb({ crumbs, key }) ? (
            <Styled.Last className="last" key={key}>
              <>{name}</>
            </Styled.Last>
          ) : (
            <Styled.Link key={key} to={path}>
              <>{name}</>
            </Styled.Link>
          )}
        </Styled.Breadcrumb>
      ))}
    </Styled.Container>
  );
};

export { Breadcrumbs };
